import { Component, Input, HostListener } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import type { FileConflictOptions } from '../services/fileConflict.service'

@Component({
  templateUrl: './fileConflictModal.component.pug',
})
export class FileConflictModalComponent {
  @Input() options: FileConflictOptions

  constructor (private modal: NgbActiveModal) { }

  @HostListener('document:keydown.enter', ['$event'])
  @HostListener('document:keydown.space', ['$event'])
  private onEnter (event) {
    event.preventDefault()
    event.stopPropagation()
    this.doOverwrite()
  }

  @HostListener('document:keydown.escape', ['$event'])
  private onEscape () {
    this.doCancel()
  }

  doOverwrite () {
    this.modal.close({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'overwrite',
    })
  }

  doRename () {
    this.modal.close({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'rename',
    })
  }

  doSkip () {
    this.modal.close({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'skip',
    })
  }

  doCancel () {
    this.modal.close({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'cancel',
    })
  }
}
